export const RESET = 'GROUP_UPDATE_RESET'
export const SET_ERROR = 'GROUP_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'GROUP_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'GROUP_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'GROUP_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'GROUP_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'GROUP_UPDATE_UPDATE_RETRIEVED'
